import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import './index.scss';
import { useEffect, useState } from 'react';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoSpace from 'eco-design/base/eco-space';
import { useLang } from '@/i18n';
import useCardsShowHook from '../useHooks/useCardsShowHook';

export default function Content({ type }: { type: string }) {
    const { locale } = getLocal();
    const prefixCls = 'image-background-card';
    const { t } = useLang('business');
    const { t: s } = useLang('business.C');
    const { isPad, isH5 } = useDeviceDetect();

    const list: { [key: string]: any } = {
        [t('tab_title_4')]: [
            {
                title: s('tab1_title_1'),
                desc: s("tab1_desc_1"),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1767092831722/PC-ksp%2001.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1767092831205/hbc-ksp-mob-01.jpg',
                titleColor: '#000',
                descColor: '#E6E6E7',
            },
            {
                title: s('tab1_title_2'),
                desc: s("tab1_desc_2"),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383492169/4-ksp-2.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383490765/4-ksp-h5-2.jpg',
                titleColor: '#fff',
                descColor: '#E6E6E7',
            },
            {
                title: s('tab1_title_3'),
                desc: s("tab1_desc_3"),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383492353/4-ksp-3.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383491956/4-ksp-h5-3.jpg',
                titleColor: '#000',
                descColor: '#000',
            },
            {
                title: s('tab1_title_4'),
                desc: s("tab1_desc_4"),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383491366/4-ksp-4.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383491768/4-ksp-h5-4.jpg',
                titleColor: '#fff',
                descColor: '#E6E6E7',
            },
            {
                title: s('tab1_title_5'),
                desc: s("tab1_desc_5"),
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383491147/4-ksp-5.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383491588/4-ksp-h5-5.jpg',
                titleColor: '#fff',
                descColor: '#E6E6E7',
            },
        ],
        [t('tab_title_5')]: [
            {
                title: s('tab2_title_1'),
                desc: [
                    {
                        label: s('tab2_label_1_1'),
                        desc: s('tab2_desc_1_1'),
                    },
                    {
                        label: s('tab2_label_1_2'),
                        desc: s('tab2_desc_1_2'),
                    },
                    {
                        label: s('tab2_label_1_3'),
                        desc: s('tab2_desc_1_3'),
                    },

                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383685353/oasis-ksp-01.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383684805/oasis-ksp-01%20(1).jpg',
                titleColor: '#fff',
                labelColor: '#fff',
                descColor: '#E6E6E7',
                active: false,
            },
            {
                title: s('tab2_title_2'),
                desc: [
                    {
                        label: s('tab2_label_2_1'),
                        desc: s('tab2_desc_2_1'),
                    },
                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383686470/oasis-ksp-02.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383684991/oasis-ksp-02%20(1).jpg',
                titleColor: '#fff',
                labelColor: '#fff',
                descColor: '#E6E6E7',
                active: false,
            },
            {
                title: s('tab2_title_3'),
                desc: [
                    {
                        label: s('tab2_label_3_1'),
                        desc: s('tab2_desc_3_1'),
                    },

                ],
                pc: 'https://websiteoss.ecoflow.com/upload/image/1766383685532/oasis-ksp-03.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1766383686285/oasis-ksp-03%20(1).jpg',
                titleColor: '#fff',
                labelColor: '#fff',
                descColor: '#E6E6E7',
                active: false,
            },
        ]
    }
    const [listArr, setListArr] = useState(list);

    useCardsShowHook('.editor-image-background-card-business .dynamic', '.editor-image-background-card-business');
    return (
        <section className={`editor-image-background-card-business ${s('title')}-business-C GtmModuleData-section`}
            id={`${s('title')}-business-C`}
            data-section-id={`${s('title')}-business-C`}
            data-section-title={`${s('title')}-business-C`}
        >
            <EcoSpace />
            <div className="eco-content-v2 dynamic">
                <h2 className={`${prefixCls}-title`}>{s('title')}</h2>
            </div>

            <div className={`${prefixCls}-list-out`}>
                <Swiper
                    className={`${prefixCls}-swiper dynamic`}
                    modules={[Navigation]}
                    navigation={listArr[type].length > 2}
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    initialSlide={0}
                >
                    {listArr[type]?.map((itemA: any, index: number) => (
                        <SwiperSlide className={`${prefixCls}-item`} key={index}>
                            <EcoLink href={itemA.href} className={`${prefixCls}-item-link ${type === t('tab_title_5') ? `Oasis-item ` : ''}  ${isPad || isH5 ? itemA.active ? 'showH5bg' : '' : 'pcBg'}`} onClick={() => {
                                if (isPad || isH5) {
                                    listArr[type][index].active = !listArr[type][index].active
                                    setListArr({ ...listArr })

                                }
                            }}>
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className={`${prefixCls}-item-img`} />
                                <div className={`${prefixCls}-item-bg `}></div>
                                {type === t('tab_title_4') && < div className={`${prefixCls}-item-msg `}>
                                    <div className={`${prefixCls}-item-title`} style={{ color: itemA?.titleColor }}>
                                        {itemA.title}
                                    </div>
                                    <div className={`${prefixCls}-bottom`}>
                                        {/* <div className={`${prefixCls}-item-label`}>{itemA.label}</div> */}
                                        <div className={`${prefixCls}-item-desc`} style={{ color: itemA?.descColor }}>{itemA.desc}</div>

                                    </div>

                                </div>}
                                {type === t('tab_title_5') && <div className={`${prefixCls}-item-msg ${isPad || isH5 ? 'h5' : 'pc'}`}>
                                    <div className={`${prefixCls}-item-title`} style={{ color: itemA?.titleColor }}>
                                        {itemA.title}
                                    </div>
                                    <div className={`${prefixCls}-bottom ${itemA.active ? 'showDesc' : ''}`}>

                                        {
                                            itemA.desc.map((item, index) => {
                                                return <div className={`${prefixCls}-bottom-item`}>
                                                    <div className={`${prefixCls}-item-label`} style={{ color: itemA?.labelColor }}>{item.label}</div>
                                                    <div className={`${prefixCls}-item-desc`} style={{ color: itemA?.descColor }}>{item.desc}</div>
                                                </div>

                                            })
                                        }
                                    </div>
                                    <span className={`svg ${itemA.active ? 'edgSvg' : ''}`} >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                            <path opacity="0.1" d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="white" />
                                            <path opacity="0.1" d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z" fill="white" />
                                            <path d="M28.2492 19.9136H11.75M20.025 11.6641V28.1632" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </div>}

                            </EcoLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <EcoSpace />
        </section >
    );
}
